import CardCoin from "@assets/icons/card-coin.svg";
import Card from "@assets/icons/card.svg";
import EmptyWallet from "@assets/icons/empty-wallet.svg";
import Home from "@assets/icons/home.svg";
import MoneySend from "@assets/icons/money-send.svg";
import ReceiptSearch from "@assets/icons/receipt-search.svg";
import Logo from "@assets/img/logo.svg";
import { Button } from "@components/button";
import { Header, LeadHeader } from "@components/header";
import { Menu, MenuConfig } from "@components/menu";
import { useAuth } from "@features/auth";
import { Outlet } from "react-router-dom";
import styles from "./layout.module.scss";
import ErrorBoundary from "@components/errorBoundary";
import { useEffect, useState } from "react";

const traderMenuConfig: MenuConfig = [
  { name: "Главная", link: "", icon: <Home /> },
  { name: "Сделки", link: "deals", icon: <CardCoin /> },
  { name: "Реквизиты", link: "details", icon: <Card /> },
  { name: "Финансы", link: "finance", icon: <EmptyWallet /> },
  { name: "Устройства", link: "devices", icon: <ReceiptSearch /> },
  { name: "Выводы", link: "payouts", icon: <MoneySend /> },
];

export const TraderLayout = () => {
  return (
    <main className={styles.layout}>
      <Menu config={traderMenuConfig} />
      <div className={styles.wrapper}>
        <Header />
        <div className={styles.content}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </div>
    </main>
  );
};

const leadMenuConfig: MenuConfig = [
  { name: "Сделки", link: "" /* , icon: <MoneySend /> */ },
  { name: "Партнеры", link: "partners" /* , icon: <MoneySend /> */ },
  { name: "История выводов", link: "withdrawals" /* , icon: <MoneySend /> */ },
];

export const LeadLayout = () => {
  return (
    <main className={styles.layout}>
      <Menu config={leadMenuConfig} />
      <div className={styles.wrapper}>
        <LeadHeader />
        <div className={styles.content}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </div>
    </main>
  );
};

const merchantMenuConfig: MenuConfig = [
  { name: "Главная", link: "", icon: <Home /> },
  { name: "Сделки", link: "deals", icon: <CardCoin /> },
  { name: "Кассы", link: "cash-registers", icon: <Card /> },
  { name: "Финансы", link: "finance", icon: <EmptyWallet /> },
  { name: "Выводы", link: "withdrawals", icon: <MoneySend /> },
];

export const MerchantLayout = () => {
  return (
    <main className={styles.layout}>
      <Menu config={merchantMenuConfig} />
      <div className={styles.wrapper}>
        <Header />
        <div className={styles.content}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </div>
    </main>
  );
};

export const AdminLayout = () => {
  const { state } = useAuth();

  const [config, setConfig] = useState<MenuConfig>([]);

  useEffect(() => {
    const tempConfig: MenuConfig = [];
    if (state.roles) {
      tempConfig.push(
        { name: "Пользователи", link: "users" },
        { name: "Сделки", link: "deals" },
        { name: "Выводы", link: "settlements" },
        { name: "Споры", link: "appeals" },
        { name: "Выводы на кошельки", link: "withdrawals" }
      );
      if (state.roles?.includes("super_user")) {
        tempConfig.push(
          { name: "Финансы", link: "finance" },
          { name: "Банки", link: "banks" },
          { name: "Уведомления бот", link: "notfication-bot" }
        );
      }
    }
    setConfig(tempConfig);
  }, [state.roles]);
  return (
    <main className={styles.layout}>
      <Menu config={config} />
      <div className={styles.wrapper}>
        <Header />
        <div className={styles.content}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </div>
      </div>
    </main>
  );
};

export const AuthLayout = () => {
  return (
    <div className={styles.container}>
      <div className={styles.block}>
        <Logo className={styles.logo} />
        <Outlet />
      </div>
    </div>
  );
};

export const AuthWithExitLayout = () => {
  const { logout } = useAuth();

  return (
    <div className={styles.container}>
      <div className={styles.block}>
        <div className={styles.blockHeader}>
          <Logo className={styles.logo} />
          <div>
            <Button onClick={logout} type="outline" className={styles.button}>
              Выход
            </Button>
          </div>
        </div>
        <Outlet />
      </div>
    </div>
  );
};
